import { all } from "redux-saga/effects";

import { sagas as anoLetivo } from "./ano-letivo";
import { sagas as calculoAvaliacao } from "./calculo-avaliacoes";
import { sagas as categorias } from "./categorias";
import { sagas as diarios } from "./relatorios/diarios/modelos";
import { sagas as logoff } from "./auth/logoff";
import { sagas as papeis } from "./relatorios/configuracoes/papeis";
import { sagas as validate } from "./auth/validate";
import { sagas as sistemaAvaliacao } from "./sistema-avaliacao";
import { sagas as feriados } from "./feriados";

export function* rootSaga(): any {
  return yield all([
    anoLetivo,
    calculoAvaliacao,
    categorias,
    diarios,
    feriados,
    logoff,
    papeis,
    validate,
    sistemaAvaliacao,
  ]);
}
